import styled from 'styled-components'
import { colors } from '../../styles/vars/colors.style'

export const ExpeditionsMaskMain = styled.div`
  position: fixed;
  inset: 0;
  transform-origin: 0 0;
  z-index: 1;
  pointer-events: none;
  background-color: ${props => props.color || colors.light};
  opacity: 0;
`
